import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../actions/types';
import { requestAPI } from '../services/request';
import { API } from '../services/api';
import { ResponseStatus } from '../../constants/constant';

function* getEmailReservation(action) {
  let response = null;
  try {
    response = yield call(
      requestAPI,
      API.API_GET_EMAIL_RESERVATION,
      API.GET,
      action.params
    );

    if (response.status === ResponseStatus.SUCCESS) {
      yield put({
        type: types.GET_EMAIL_RESERVATION_SUCCEEDED,
        data: response.data
      });
    } else {
      yield put({ type: types.GET_EMAIL_RESERVATION_FAILED, error: response });
    }

    if (action.onComplete) {
      action.onComplete(response);
    }
  } catch (error) {
    yield put({ type: types.GET_EMAIL_RESERVATION_FAILED, error });
  }
}

export function* watchGetEmailReservation() {
  yield takeLatest(types.GET_EMAIL_RESERVATION_REQUESTED, getEmailReservation);
}
